<div class="modal-header bg-primary text-white">
  <h5 class="modal-title">Layers</h5>
  <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body layer-body">
  <ul class="nav nav-tabs">
    <li [class.active]="activeTab === 'entities'">
      <a class="nav-link" [class.active]="activeTab === 'entities'" (click)="setActiveTab('entities')">Entities</a>
    </li>
    <li [class.active]="activeTab === 'imagery'">
      <a class="nav-link" [class.active]="activeTab === 'imagery'" (click)="setActiveTab('imagery')">Imagery</a>
    </li>
  </ul>
  <div class="tab-content mt-3">
    @if (activeTab === 'entities') {
      <div class="tab-pane active">
        <div class="custom-scroll" >
          <div #layersTree class="layers-tree">
            @for (node of treeData; track trackByNodeId($index, node)) {
              <div class="tree-node">
                <app-tree-node
                  [node]="node"
                  [level]="0"
                  (nodeSelected)="onNodeSelected($event)"
                  (nodeChecked)="onNodeChecked($event)"
                  (nodeUnchecked)="onNodeUnchecked($event)">
                </app-tree-node>
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if (activeTab === 'imagery') {
      <div class="tab-pane fade">
        <div class="custom-scroll" >
          Imagery content goes here.
        </div>
      </div>
    }
  </div>
</div>